import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss'],
  standalone: true,
  imports: []
})


export class NotfoundComponent implements OnInit {

  constructor(
    private _router: Router
  ) { }

  ngOnInit() { }

  goToSignin() {
    this._router.navigate(['/signin']);
  }


}
